import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflow: "hidden",
    backgroundColor: "#2f2f2f",
    minHeight: "100vh",
  },
  mainContent: {
    width: "100%",
    minHeight: "100vh",
  },
  copyright: {
    marginBottom: 0,
    padding: 15,
    background: "rgb(15,15,15)",
    textAlign: "center",
    width: "100%",
    height: "auto",
    "& p": {
      textDecoration: "none",
      color: "white",
    },
  },
}));
